import { ChangeDetectionStrategy, Component, inject, Input, OnInit, signal } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { EmailConfig } from '../../../models/email-config.model';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { EmailListService } from '../../../services/email-list.service';
import { NotificationService } from '../../../services/notification.service';
import { EmailConfigListService } from '../../../services/email-config-list.service';

@Component({
  selector: 'app-modal-add-email-config',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogActions,
    MatDialogContent,
    MatDialogClose,
    MatIconModule,
    MatCardModule,
    MatSelectModule,
    MatSlideToggleModule,
    
  ],
  templateUrl: './modal-add-email-config.component.html',
  styleUrl: './modal-add-email-config.component.css'
})
export class ModalAddEmailConfigComponent implements OnInit {

  public dialogRef?: MatDialogRef<ModalAddEmailConfigComponent> = inject(MatDialogRef);

  constructor(
    private emailListService: EmailConfigListService,
    private notificationService: NotificationService
  ) { }

  readonly dialog = inject(MatDialog);

    public currentAccount: EmailConfig = {
      id: 0,
      rekbot_id: 0,
      email: "",
      report: 0,
      error: 0,
      alert: 0
    };

  public editForm: FormGroup = new FormGroup({
    id: new FormControl(0),
    email: new FormControl('', [Validators.required]),
    report: new FormControl(0, []),
    error: new FormControl(0, []),
    alert: new FormControl(0, []),
    rekbot_id: new FormControl(0)
  });

  ngOnInit(): void {
    this.currentAccount = this.emailListService.getCurrentEmail();
    this.editForm.setValue({
      id: this.currentAccount.id,
      email: this.currentAccount.email,
      report: this.currentAccount.report,
      error: this.currentAccount.error,
      alert: this.currentAccount.alert,
      rekbot_id: this.currentAccount.rekbot_id
    });
  }

  onSubmit() {
    console.log(this.editForm.value);
    const currentRekbot = this.emailListService.getCurrentRekbotId();

    if(this.editForm.value.id === 0) {
      this.emailListService.addEmail(currentRekbot, this.editForm.value).subscribe({
        next: (data: any) => {
          //this.notificationService.showSuccess('Dodano email');
          this.notificationService.pushNotification('Dodano email', 'info');
          this.dialogRef?.close();
        },
        error: (error: any) => {
          this.notificationService.pushNotification('Błąd podczas dodawania emaila', 'error');
          //this.notificationService.showError('Błąd podczas dodawania emaila');
        }
      });
    } else {
      this.emailListService.updateEmail(currentRekbot, this.editForm.value).subscribe({
        next: (data: any) => {
          //this.notificationService.showSuccess('Zaktualizowano email');
          this.notificationService.pushNotification('Zaktualizowano email', 'info');
          this.dialogRef?.close();
        },
        error: (error: any) => {
          this.notificationService.pushNotification('Błąd podczas aktualizacji emaila', 'error');
          //this.notificationService.showError('Błąd podczas aktualizacji emaila');
        }
      });
    }
  }


  checkDisabled() {
    return this.editForm.invalid;
  }


  getSaveText() {
    if (this.editForm.value.id === '' || this.editForm.value.id === null || this.editForm.value.id === undefined || this.editForm.value.id === 0) {
      return 'Dodaj';
    } else {
      return 'Zapisz';
    }
  }

  getTitle() {
    if (this.editForm.value.id === '' || this.editForm.value.id === null || this.editForm.value.id === undefined || this.editForm.value.id === 0) {
      return 'Dodaj email';
    } else {
      return 'Edycja';
    }
  }


}
